import { connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as personalisationActions,
  InteractionErrorTrackingEvent,
  InteractionTrackingEvent,
  ProgressTrackingEvent,
  selectNumberOfRequiredPersonalisations,
  selectOutstandingPersonalisations,
  selectTotalPrice,
  selectTrackedEvents,
} from 'src/redux/personalisation';
import { selectPersonalisationOptions } from 'src/redux/selectors';
import {
  DispatchProps,
  MultipleOptionSelectionDrawer,
} from '../components/MultipleOptionSelection/MultipleOptionSelectionDrawer';

const mapStateToProps = (state: ReduxApplicationState) => ({
  options: selectPersonalisationOptions(state),
  totalPrice: selectTotalPrice(state),
  totalOutstandingSelections: selectOutstandingPersonalisations(state).length,
  totalRequiredPersonalisations: selectNumberOfRequiredPersonalisations(state),
  trackedEvents: selectTrackedEvents(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  trackInteraction: (payload: InteractionTrackingEvent) =>
    dispatch(personalisationActions.trackInteraction(payload)),
  trackProgressMilestone: (payload: ProgressTrackingEvent) =>
    dispatch(personalisationActions.trackProgressMilestone(payload)),
  trackInteractionError: (payload: InteractionErrorTrackingEvent) =>
    dispatch(personalisationActions.trackInteractionError(payload)),
});

export const MultipleOptionSelectionDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultipleOptionSelectionDrawer);
